/* eslint-disable max-len */

import { I18nUtils } from '../../../i18n/I18nUtils';
import cookie from 'react-cookies';
import { AUTH_TOKEN } from '../utils/CookiesManager';
import Config from '../../../Config';
import { LoginManagerInstance } from '../../login/LoginManager';

export const METHOD_POST = 'POST';
export const METHOD_GET = 'GET';
export const METHOD_PUT = 'PUT';
export const METHOD_DELETE = 'DELETE';

export default class GenericRequest {
    url;
    successFunction;
    failFunction;
    onPreExecutionFunction;
    onPostExecutionFunction;
    method;
    errorMessages;
    headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    /*
        EJEMPLO DE LOCATION EN TEST (NO LOCALHOST)

        location {
            ancestorOrigins: {}
            hash: ""
            host: "pavasalapptest.cuatroochenta.com"
            hostname: "pavasalapptest.cuatroochenta.com"
            href: "https://pavasalapptest.cuatroochenta.com/admin/"
            origin: "https://pavasalapptest.cuatroochenta.com"
            pathname: "/admin/"
            port: ""
            protocol: "https:"
            search: ""
        }

        ¡OJO! Si no se pasa una dirección sin el "https://" al principio el fetch inserta el "referer" por lo que se
        genera esta llamada:
        https://pavasalapptest.cuatroochenta.com/admin/pavasalapptest.cuatroochenta.com/login
    */
    determineHostname() {
        const {hostname, origin} = window.location;
        if ( hostname === 'localhost' ) return Config.API;
        return origin;
    }

    error = (error, errorCode) => {
        if ( error.stack ) {
            if ( this.failFunction ) this.failFunction(I18nUtils.tr('TR_ERROR_OBTENIENDO_INFORMACION'));
            if ( this.onPostExecutionFunction ) this.onPostExecutionFunction();
        } else if ( errorCode && this.errorMessages[errorCode] ) {
            if ( this.failFunction ) this.failFunction(this.errorMessages[errorCode]);
            if ( this.onPostExecutionFunction ) this.onPostExecutionFunction();
        } else if ( errorCode ) {
            if ( this.failFunction ) this.failFunction(I18nUtils.tr('TR_ERROR_OBTENIENDO_INFORMACION'));
            if ( this.onPostExecutionFunction ) this.onPostExecutionFunction();
        } else {
            if ( this.failFunction ) this.failFunction(error.toString());
            if ( this.onPostExecutionFunction ) this.onPostExecutionFunction();
        }
    };

    success = (response) => {
        let responseObj = {};
        if ( response ) responseObj = response;

        if (!responseObj.success && responseObj.code === 401) {
            LoginManagerInstance.logout();
        }

        if ( responseObj.success ) {
            if ( this.successFunction ) this.successFunction(responseObj);
        } else {
            if ( this.failFunction ) this.failFunction(
                responseObj.message
                    ? responseObj.message
                    : I18nUtils.tr('TR_ERROR_OBTENIENDO_INFORMACION'),
                responseObj.worker_id
                    ? responseObj.worker_id
                    : null
            );
        }
        if ( this.onPostExecutionFunction ) this.onPostExecutionFunction();
    };

    addHeader(key, value) {
        this.headers[key] = value;
    }

    removeHeader(key) {
        delete this.headers[key];
    }

    setErrorMessage(code, message) {
        this.errorMessages[code] = message;
    }

    constructor(method = METHOD_POST, url) {
        this.method = method;
        this.url = this.determineHostname() + url;
        this.errorMessages = {};
    }

    overrideRequest() {}

    onPreExecution(onPreExecutionFunction) {
        this.onPreExecutionFunction = onPreExecutionFunction;
        return this;
    }

    onPostExecution(onPostExecutionFunction) {
        this.onPostExecutionFunction = onPostExecutionFunction;
        return this;
    }

    onSuccess(successFunction) {
        this.successFunction = successFunction;
        return this;
    }

    onFail(failFunction) {
        this.failFunction = failFunction;
        return this;
    }

    execute() {
        if ( this.onPreExecutionFunction ) this.onPreExecutionFunction();
        const request = this.overrideRequest();

        let header = {};

        // JWT
        const authToken = cookie.load(AUTH_TOKEN);
        if ( authToken ) {
            header.Authorization = 'Bearer ' + cookie.load(AUTH_TOKEN);
        }

        header = {...header, ...this.headers};

        if ( this.method === METHOD_GET ) {
            fetch(this.url, {
                method: this.method,
                headers: header,
                mode: 'cors',
            })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    this.success(data);
                })
                .catch(this.error);
        } else {
            fetch(this.url, {
                method: this.method,
                headers: header,
                body: request instanceof FormData ? request : JSON.stringify(request),
                mode: 'cors',
            })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    this.success(data);
                })
                .catch(this.error);
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/shared/webservices/GenericRequest.js